import { createFileRoute } from "@tanstack/react-router";
import CurlConverterPage from "@/pages/CurlConverterPage";

export const Route = createFileRoute("/tools/curl-converter")({
  component: CurlConverterPage,
});
